import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SignaturePad from './SignaturePad';
import '../styles/HptScreens.css';
import imagenFondo from '../assets/logo_elecnor.jpg';
import Swal from 'sweetalert2';
import html2pdf from 'html2pdf.js';

const API_URL = process.env.REACT_APP_API_URL;

const PermisoEspaciosConfinados = ({ datosPrevios, usuarioActual, onSave, onCancel, readOnly = false, isPdfMode = false }) => {
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [currentSignField, setCurrentSignField] = useState(null);

    const { id } = useParams(); 
    const navigate = useNavigate();
    const isStandalone = typeof onSave !== 'function';
    const pdfRef = useRef();
    const [isPrintingLocal, setIsPrintingLocal] = useState(false);

    const [formData, setFormData] = useState({
        sg_direccion: '', delegacion: '', cp: '', espacio_confinado: '', descripcion_trabajos: '', fecha: '', realizado_por_mando: '',
        check_1_1: '', check_1_2: '', check_1_3: '', check_1_4: '', check_1_5: '', check_1_6: '', check_1_7: '',
        eq_casco: '', eq_detector: '', eq_comunicacion: '', eq_ventilacion: '', eq_ropa: '', num_serie_detector: '',
        eq_barandillas: '', eq_senalizacion: '', eq_arnes: '', eq_respiracion: '', eq_iluminacion: '', eq_bomba: '', eq_rescate: '', eq_mascarillas: '', eq_extintores: '',
        antes_1: '', antes_2: '', antes_3: '', antes_4: '', antes_5: '', antes_6: '',
        medicion_segura: '', lectura_o2: '', cumple_o2: '', lectura_ch4: '', cumple_ch4: '', lectura_co: '', cumple_co: '', lectura_sh2: '', cumple_sh2: '',
        vent_1: '', vent_2: '', vent_3: '', vent_adecuada: '', resultado_medicion: '',
        personal_1: '', personal_2: '', personal_3: '', personal_4: '', personal_5: '', personal_6: '',
        firma_jefe_equipo: null, firma_encargado: null, firma_jefe_obra: null
    });

    useEffect(() => {
        if (isStandalone && id) {
            const cargarDatos = async () => {
                try {
                    const token = localStorage.getItem('userToken');
                    const res = await axios.get(`${API_URL}/api/hpt/confinados/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    
                    const dbData = res.data;
                    setFormData({
                        sg_direccion: dbData.sg_direccion || "", delegacion: dbData.delegacion || "", cp: dbData.cp || "",
                        espacio_confinado: dbData.espacio_confinado || "", descripcion_trabajos: dbData.descripcion_trabajos || "", fecha: dbData.fecha || "", 
                        realizado_por_mando: dbData.realizado_por_mando || "",
                        check_1_1: dbData.check_1_1 || "", check_1_2: dbData.check_1_2 || "", check_1_3: dbData.check_1_3 || "", check_1_4: dbData.check_1_4 || "",
                        check_1_5: dbData.check_1_5 || "", check_1_6: dbData.check_1_6 || "", check_1_7: dbData.check_1_7 || "",
                        eq_casco: dbData.eq_casco || "", eq_detector: dbData.eq_detector || "", eq_comunicacion: dbData.eq_comunicacion || "", 
                        eq_ventilacion: dbData.eq_ventilacion || "", eq_ropa: dbData.eq_ropa || "", num_serie_detector: dbData.num_serie_detector || "",
                        eq_barandillas: dbData.eq_barandillas || "", eq_senalizacion: dbData.eq_senalizacion || "", eq_arnes: dbData.eq_arnes || "", 
                        eq_respiracion: dbData.eq_respiracion || "", eq_iluminacion: dbData.eq_iluminacion || "", eq_bomba: dbData.eq_bomba || "", 
                        eq_rescate: dbData.eq_rescate || "", eq_mascarillas: dbData.eq_mascarillas || "", eq_extintores: dbData.eq_extintores || "",
                        antes_1: dbData.antes_1 || "", antes_2: dbData.antes_2 || "", antes_3: dbData.antes_3 || "", 
                        antes_4: dbData.antes_4 || "", antes_5: dbData.antes_5 || "", antes_6: dbData.antes_6 || "",
                        medicion_segura: dbData.medicion_segura || "", 
                        lectura_o2: dbData.lectura_o2 || "", cumple_o2: dbData.cumple_o2 || "", 
                        lectura_ch4: dbData.lectura_ch4 || "", cumple_ch4: dbData.cumple_ch4 || "", 
                        lectura_co: dbData.lectura_co || "", cumple_co: dbData.cumple_co || "", 
                        lectura_sh2: dbData.lectura_sh2 || "", cumple_sh2: dbData.cumple_sh2 || "",
                        vent_1: dbData.vent_1 || "", vent_2: dbData.vent_2 || "", vent_3: dbData.vent_3 || "", vent_adecuada: dbData.vent_adecuada || "", 
                        resultado_medicion: dbData.resultado_medicion || "",
                        personal_1: dbData.personal_1 || "", personal_2: dbData.personal_2 || "", personal_3: dbData.personal_3 || "", 
                        personal_4: dbData.personal_4 || "", personal_5: dbData.personal_5 || "", personal_6: dbData.personal_6 || "",
                        firma_jefe_equipo: dbData.firma_jefe_equipo ? JSON.parse(dbData.firma_jefe_equipo) : null,
                        firma_encargado: dbData.firma_encargado ? JSON.parse(dbData.firma_encargado) : null,
                        firma_jefe_obra: dbData.firma_jefe_obra ? JSON.parse(dbData.firma_jefe_obra) : null
                    });
                } catch (error) {
                    Swal.fire('Error', 'No se pudo cargar el documento', 'error');
                }
            };
            cargarDatos();
        }
    }, [id, isStandalone]);

    const handleGuardarDirecto = async () => {
        try {
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const payload = { ...formData, id_hpt: null };

            if (id) {
                await axios.put(`${API_URL}/api/hpt/confinados/${id}`, payload, config);
                Swal.fire({
                    title: "¡Actualizado!", text: `Registro actualizado correctamente`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }else{
                const res = await axios.post(`${API_URL}/api/hpt/confinados`, payload, config);

                Swal.fire({
                    title: "¡Guardado!", text: `Registrado con ID: ${res.data.id_registro}`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudo guardar en el servidor.', 'error');
        }
    };

    

    const handleChange = (e) => {
        if (readOnly) return;
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSign = (signatureBase64) => {
        const fechaHora = new Date().toLocaleString('es-ES');
        let nombreCompleto = usuarioActual;
        
        if (!nombreCompleto) {
            const token = localStorage.getItem('userToken');
            if (token) {
                const dec = JSON.parse(atob(token.split('.')[1]));
                nombreCompleto = `${dec.nombre || ''} ${dec.apellidos || ''}`.trim() || dec.user;
            } else {
                nombreCompleto = 'Usuario Desconocido';
            }
        }

        setFormData({
            ...formData,
            [currentSignField]: { base64: signatureBase64, nombre: nombreCompleto, fechaHora: fechaHora }
        });
        setShowSignaturePad(false);
        setCurrentSignField(null);
    };

    const clearSignature = (field) => {
        if (readOnly) return;
        setFormData({ ...formData, [field]: null });
    };

    // Helper para pintar las celdas de SI/NO rápidamente
    const renderRadioTd = (name, value) => (
        <td style={{ textAlign: 'center' }}>
            <input type="radio" name={name} value={value} checked={formData[name] === value} onChange={handleChange} disabled={readOnly} style={{ transform: 'scale(1.3)', cursor: 'pointer', margin: 0 }} />
        </td>
    );

    const handleDescargarPDF = () => {
        setIsPrintingLocal(true);
        Swal.fire({ title: 'Generando documento...', text: 'Por favor espera', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        setTimeout(() => {
            const element = pdfRef.current;
            const opt = {
                margin:       [10, 5, 10, 5],
                filename:     `Permiso_${new Date().getTime()}.pdf`,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2, useCORS: true, windowWidth: 720 },
                jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
                pagebreak:    { mode: ['css', 'legacy'] }
            };
            html2pdf().set(opt).from(element).save().then(() => {
                setIsPrintingLocal(false);
                Swal.close();
            });
        }, 800);
    };

    const contenidoFormulario = (
        <div className="confi-overlay">
            <div className={`confi-modal ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}>
                <div ref={pdfRef}
                    className={`pe-container ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}
                    style={isPrintingLocal ? { width: '720px', maxWidth: '720px', margin: '0 auto', backgroundColor: '#fff', transform: 'none' } : {}}

                >
                
                    {/* CABECERA DOCUMENTO */}
                    <table className="confi-table-noborder">
                        <tbody>
                            <tr>
                                <td style={{ width: '20%' }}><img src={imagenFondo} alt="Logo" style={{ maxHeight: '40px' }} /></td>
                                <td style={{ width: '60%' }}><h2 className="confi-main-title">AUTORIZACIÓN DE ENTRADA A ESPACIO CONFINADO</h2></td>
                                <td style={{ width: '20%' }}>FI.ELN.GEN-08.04D<br/>Rev. 00<br/>(modificado)</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* BLOQUE INICIAL */}
                    <table className="confi-table">
                        <tbody>
                            <tr>
                                <td style={{ width: '33%' }}><div style={{display: 'flex'}}><strong>S.G./DIRECCIÓN:</strong><input type="text" className="confi-input" name="sg_direccion" value={formData.sg_direccion} onChange={handleChange} disabled={readOnly} /></div></td>
                                <td style={{ width: '33%' }}><div style={{display: 'flex'}}><strong>DELEGACIÓN:</strong><input type="text" className="confi-input" name="delegacion" value={formData.delegacion} onChange={handleChange} disabled={readOnly} /></div></td>
                                <td style={{ width: '34%' }}><div style={{display: 'flex'}}><strong>C.P.:</strong><input type="text" className="confi-input" name="cp" value={formData.cp} onChange={handleChange} disabled={readOnly} /></div></td>
                            </tr>
                            <tr>
                                <td colSpan="3"><div style={{display: 'flex'}}><strong>Espacio confinado (depósito, cámara de registro, pozo, etc):</strong><br/><input type="text" className="confi-input" name="espacio_confinado" value={formData.espacio_confinado} onChange={handleChange} disabled={readOnly} /></div></td>
                            </tr>
                            <tr>
                                <td colSpan="3"><strong>DESCRIPCIÓN DE LOS TRABAJOS:</strong><br/><textarea className="confi-input" rows="2" name="descripcion_trabajos" value={formData.descripcion_trabajos} onChange={handleChange} disabled={readOnly} /></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><strong>REALIZADO POR EL MANDO:</strong><input type="text" className="excel-input-border" style={{ width: '250px', marginLeft: '10px' }} name="realizado_por_mando" value={formData.realizado_por_mando} onChange={handleChange} disabled={readOnly} /></td>
                                <td  colSpan= "1" style={{ textAlign: 'right', width: '250px' }}><strong>FECHA:</strong> <input type="date" className="confi-input-border" style={{ width: '150px' }} name="fecha" value={formData.fecha} onChange={handleChange} disabled={readOnly} /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* 1. ORGANIZACIÓN Y MEDIOS */}
                    <div className="confi-subtitle">1.- ORGANIZACIÓN Y MEDIOS, PARA ENTRADA EN ESPACIOS CONFINADOS:</div>

                    <table className="confi-table">
                        <thead>
                            <tr><th></th><th style={{ width: '40px', textAlign: 'center' }}>SI</th><th style={{ width: '40px', textAlign: 'center' }}>NO</th></tr>
                        </thead>
                        <tbody>
                            <tr><td>1. ¿Dispones del personal necesario en número y cualificación para los trabajos a realizar?</td>{renderRadioTd('check_1_1', 'SI')}{renderRadioTd('check_1_1', 'NO')}</tr>
                            <tr><td>2. ¿Está el recurso preventivo presente? (normalmente, es el mando)</td>{renderRadioTd('check_1_2', 'SI')}{renderRadioTd('check_1_2', 'NO')}</tr>
                            <tr><td>3. ¿Conoces con detalle las tareas a realizar, con los datos que sean necesarios?</td>{renderRadioTd('check_1_3', 'SI')}{renderRadioTd('check_1_3', 'NO')}</tr>
                            <tr><td>4. ¿Hemos explicado a la brigada las tareas a realizar y los riesgos existentes?</td>{renderRadioTd('check_1_4', 'SI')}{renderRadioTd('check_1_4', 'NO')}</tr>
                            <tr><td>5. ¿Disponéis de los equipos de trabajo y herramientas necesarios para el trabajo a realizar?</td>{renderRadioTd('check_1_5', 'SI')}{renderRadioTd('check_1_5', 'NO')}</tr>
                            <tr><td>6. Al llegar al lugar del trabajo, ¿coincide el trabajo con lo previsto? Si existe alguna interferencia que complique el trabajo impida su correcto desarrollo. ¿Se puede solucionar de forma segura?</td>{renderRadioTd('check_1_6', 'SI')}{renderRadioTd('check_1_6', 'NO')}</tr>
                            <tr><td>7. ¿Has previsto, que tiene que haber un trabajador vigilando en el exterior de manera permanente por cada recinto confinado? RECUERDA QUE ES OBLIGATORIO.</td>{renderRadioTd('check_1_7', 'SI')}{renderRadioTd('check_1_7', 'NO')}</tr>
                        </tbody>
                    </table>
                    <div className="confi-alert-red">¡¡RECUERDA QUE UNA PERSONA NO PUEDE TRABAJAR SOLA EN ESTE TIPO DE INSTALACIONES!!</div>

                    {/* 2. EQUIPOS DE PROTECCIÓN */}
                    <div className="confi-subtitle">2.- EQUIPOS DE PROTECCION Y DE TRABAJO NECESARIOS:</div>
                    <table className="confi-table">
                        <thead>
                            <tr>
                                <th>OBLIGATORIOS</th><th style={{ width: '30px', textAlign: 'center' }}>SI</th><th style={{ width: '30px', textAlign: 'center' }}>NO</th>
                                <th>RECOMENDADOS SEGÚN TAREA</th><th style={{ width: '30px', textAlign: 'center' }}>SI</th><th style={{ width: '30px', textAlign: 'center' }}>NO</th><th style={{ width: '30px', textAlign: 'center' }}>NA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>CASCO, BOTAS Y GUANTES DE SEGURIDAD</td>{renderRadioTd('eq_casco', 'SI')}{renderRadioTd('eq_casco', 'NO')}
                                <td>BARANDILLAS DE PROTECCIÓN</td>{renderRadioTd('eq_barandillas', 'SI')}{renderRadioTd('eq_barandillas', 'NO')}{renderRadioTd('eq_barandillas', 'NA')}
                            </tr>
                            <tr>
                                <td>DETECTOR DE GASES</td>{renderRadioTd('eq_detector', 'SI')}{renderRadioTd('eq_detector', 'NO')}
                                <td>SEÑALIZACIÓN CALZADA</td>{renderRadioTd('eq_senalizacion', 'SI')}{renderRadioTd('eq_senalizacion', 'NO')}{renderRadioTd('eq_senalizacion', 'NA')}
                            </tr>
                            <tr>
                                <td>MEDIOS DE COMUNICACIÓN (móvil, emisoras)</td>{renderRadioTd('eq_comunicacion', 'SI')}{renderRadioTd('eq_comunicacion', 'NO')}
                                <td>ARNÉS DE SEGURIDAD + SISTEMA ANTICAÍDAS</td>{renderRadioTd('eq_arnes', 'SI')}{renderRadioTd('eq_arnes', 'NO')}{renderRadioTd('eq_arnes', 'NA')}
                            </tr>
                            <tr>
                                <td>EQUIPOS DE VENTILACIÓN</td>{renderRadioTd('eq_ventilacion', 'SI')}{renderRadioTd('eq_ventilacion', 'NO')}
                                <td>EQUIPOS DE RESPIRACIÓN AUTONOMA</td>{renderRadioTd('eq_respiracion', 'SI')}{renderRadioTd('eq_respiracion', 'NO')}{renderRadioTd('eq_respiracion', 'NA')}
                            </tr>
                            <tr>
                                <td>ROPA DE TRABAJO IGNIFUGA Y ANTIESTÁTICA (Si es necesaria)</td>{renderRadioTd('eq_ropa', 'SI')}{renderRadioTd('eq_ropa', 'NO')}
                                <td>ILUMINACION ARTIFICIAL</td>{renderRadioTd('eq_iluminacion', 'SI')}{renderRadioTd('eq_iluminacion', 'NO')}{renderRadioTd('eq_iluminacion', 'NA')}
                            </tr>
                            <tr>
                                <td colSpan="3" rowSpan="4" style={{ verticalAlign: 'top' }}>
                                    <strong>Nº DE SERIE/IDENTIFICADOR DETECTOR DE GASES</strong><br/>
                                    <input type="text" className="confi-input" name="num_serie_detector" value={formData.num_serie_detector} onChange={handleChange} disabled={readOnly} style={{ borderBottom: '1px solid #ccc', marginTop: '10px' }} />
                                </td>
                                <td>BOMBA EXTRACTORA DE AGUA</td>{renderRadioTd('eq_bomba', 'SI')}{renderRadioTd('eq_bomba', 'NO')}{renderRadioTd('eq_bomba', 'NA')}
                            </tr>
                            <tr><td>EQUIPO DE RESCATE</td>{renderRadioTd('eq_rescate', 'SI')}{renderRadioTd('eq_rescate', 'NO')}{renderRadioTd('eq_rescate', 'NA')}</tr>
                            <tr><td>MASCARILLAS</td>{renderRadioTd('eq_mascarillas', 'SI')}{renderRadioTd('eq_mascarillas', 'NO')}{renderRadioTd('eq_mascarillas', 'NA')}</tr>
                            <tr><td>EXTINTORES</td>{renderRadioTd('eq_extintores', 'SI')}{renderRadioTd('eq_extintores', 'NO')}{renderRadioTd('eq_extintores', 'NA')}</tr>
                        </tbody>
                    </table>



                    {/* 3. ANTES DE LA ENTRADA */}
                    <div className="confi-subtitle">3.- ANTES DE LA ENTRADA EN EL RECINTO:</div>
                    <table className="confi-table" style={{pageBreakInside: 'avoid'}}>
                        <thead>
                            <tr><th></th><th style={{ width: '40px', textAlign: 'center' }}>SI</th><th style={{ width: '40px', textAlign: 'center' }}>NO</th><th style={{ width: '40px', textAlign: 'center' }}>NA</th></tr>
                        </thead>
                        <tbody>
                            <tr><td>1) ¿Disponeis de los ganchos u otros medios adecuados para la manipulación de las tapas?</td>{renderRadioTd('antes_1', 'SI')}{renderRadioTd('antes_1', 'NO')}{renderRadioTd('antes_1', 'NA')}</tr>
                            <tr><td>2) ¿Se ha señalizado/delimitado la zona de trabajo, en especial en caso de zonas de tráfico?</td>{renderRadioTd('antes_2', 'SI')}{renderRadioTd('antes_2', 'NO')}{renderRadioTd('antes_2', 'NA')}</tr>
                            <tr><td>3) ¿Disponéis del detector de gases/explosimetro? (tantos como recintos en los que se trabaje a la vez)</td>{renderRadioTd('antes_3', 'SI')}{renderRadioTd('antes_3', 'NO')}</tr>
                            <tr><td>4) ¿Está en buenas condiciones y funciona el mismo correctamente? ¿Se ha medido en el exterior para su comprobación?</td>{renderRadioTd('antes_4', 'SI')}{renderRadioTd('antes_4', 'NO')}</tr>
                            <tr><td>5) ¿Has realizado una primera medición alrededor de la puerta/tapa de arqueta antes de abrirla? ¿Es correcta?</td>{renderRadioTd('antes_5', 'SI')}{renderRadioTd('antes_5', 'NO')}</tr>
                            <tr><td>6) ¿Se ha ventilado el recinto de manera natural, mediante la apertura temporal del mismo?</td>{renderRadioTd('antes_6', 'SI')}{renderRadioTd('antes_6', 'NO')}</tr>
                        </tbody>
                    </table>
                    <div className="confi-alert-orange">¡¡¡ ATENCION, Si has contestado que NO, a alguna de las preguntas de arriba NO PUEDES REALIZAR EL TRABAJO hasta solucionar ese punto !!!!</div>

                    <table className="confi-table">
                        <tbody>
                            <tr style={{ backgroundColor: '#f0f0f0' }}>
                                <td colSpan="2" rowSpan="2"><strong>6) ¿Se ha medido la atmósfera del espacio confinado y es segura para entrar?</strong></td>
                                <td colSpan="2" style={{ textAlign: 'center'}}>
                                    SI / NO
                                </td>
                            </tr>
                            <tr style={{ backgroundColor: '#f0f0f0' }}>
                                    {renderRadioTd('medicion_segura', 'SI')}
                                    {renderRadioTd('medicion_segura', 'NO')}
                            </tr>
                            <tr style={{ backgroundColor: '#f0f0f0' }}>
                                <td style={{ width: '50%' }}><strong>¿Alguno de los niveles cumple esto?</strong></td>
                                <td style={{ width: '20%', textAlign: 'center' }}><strong>Lectura</strong></td>
                                <td colSpan="2" style={{ width: '30%', textAlign: 'center' }}><strong>SI / NO</strong></td>
                            </tr>
                            <tr>
                                <td>Oxigeno % de 02 está comprendido entre de 20,5% y 23,5 %</td>
                                <td><input type="text" className="confi-input" style={{ textAlign: 'center' }} name="lectura_o2" value={formData.lectura_o2} onChange={handleChange} disabled={readOnly} /></td>
                                {renderRadioTd('cumple_o2', 'SI')}{renderRadioTd('cumple_o2', 'NO')}
                            </tr>
                            <tr>
                                <td>Metano CH4 es MENOR de 5%</td>
                                <td><input type="text" className="confi-input" style={{ textAlign: 'center' }} name="lectura_ch4" value={formData.lectura_ch4} onChange={handleChange} disabled={readOnly} /></td>
                                {renderRadioTd('cumple_ch4', 'SI')}{renderRadioTd('cumple_ch4', 'NO')}
                            </tr>
                            <tr>
                                <td>Monoxido de Carbono CO es MENOR a 25 ppm</td>
                                <td><input type="text" className="confi-input" style={{ textAlign: 'center' }} name="lectura_co" value={formData.lectura_co} onChange={handleChange} disabled={readOnly} /></td>
                                {renderRadioTd('cumple_co', 'SI')}{renderRadioTd('cumple_co', 'NO')}
                            </tr>
                            <tr>
                                <td>Acido Sulfhídrico SH2 es MENOR de 10 ppm.</td>
                                <td><input type="text" className="confi-input" style={{ textAlign: 'center' }} name="lectura_sh2" value={formData.lectura_sh2} onChange={handleChange} disabled={readOnly} /></td>
                                {renderRadioTd('cumple_sh2', 'SI')}{renderRadioTd('cumple_sh2', 'NO')}
                            </tr>
                        </tbody>
                    </table>
                    <div className="confi-alert-red">Si alguna de las respuestas es NO: ATENCION, NO PUEDES ENTRAR, TIENES QUE VENTILAR, completa el apartado 4.</div>
                    <div className="confi-alert-blue">¡¡¡ ATENCION, RECUERDA QUE EL DETECTOR DE GASES, HA DE PERMANECER ENCENDIDO, MIDIENDO, DURANTE EL TIEMPO QUE PERMANEZCAS EN EL INTERIOR DEL ESPACIO CONFINADO A TU LADO!!!</div>

                    {/* 4. VENTILACIÓN FORZADA */}
                    <div className="confi-subtitle">4.- VENTILACION FORZADA DEL ESPACIO CONFINADO:</div>
                    <table className="confi-table">
                        <thead>
                            <tr><th></th><th style={{ width: '40px', textAlign: 'center' }}>SI</th><th style={{ width: '40px', textAlign: 'center' }}>NO</th><th style={{ width: '40px', textAlign: 'center' }}>NA</th></tr>
                        </thead>
                        <tbody>
                            <tr><td>1. ¿Dispones de equipo de ventilación forzada antideflagrante, si es necesario?</td>{renderRadioTd('vent_1', 'SI')}{renderRadioTd('vent_1', 'NO')}{renderRadioTd('vent_1', 'NA')}</tr>
                            <tr><td>2. ¿Se encuentra en buen estado el ventilador?</td>{renderRadioTd('vent_2', 'SI')}{renderRadioTd('vent_2', 'NO')}{renderRadioTd('vent_2', 'NA')}</tr>
                            <tr><td>3. ¿Se encuentran en buen estado las mangueras?</td>{renderRadioTd('vent_3', 'SI')}{renderRadioTd('vent_3', 'NO')}{renderRadioTd('vent_3', 'NA')}</tr>
                            <tr style={{ backgroundColor: '#f0f0f0' }}>
                                <td><strong>¡¡ ATENCIÓN, una vez realizada la ventilación, vuelve a medir. ¿Las mediciones de gases son las adecuadas?</strong></td>
                                {renderRadioTd('vent_adecuada', 'SI')}{renderRadioTd('vent_adecuada', 'NO')}<td style={{ backgroundColor: '#fff' }}></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="confi-table-noborder" style={{ border: '1px solid #000' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '40%', padding: '10px' }}>Si tu respuesta es No, indica el resultado, cierra el espacio confinado, comunicalo a tu línea de mando y márchate.</td>
                                <td style={{ borderLeft: '1px solid #000', padding: '0' }}>
                                    <textarea className="confi-input" style={{ height: '100%', padding: '10px' }} rows="2" name="resultado_medicion" value={formData.resultado_medicion} onChange={handleChange} disabled={readOnly} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    

                    {/* 5. LISTADO PERSONAL */}
                    <div className="confi-subtitle">5.- LISTADO DEL PERSONAL QUE HA ENTRADO AL ESPACIO CONFINADO:</div>
                    <table className="confi-table-noborder" style={{ border: '1px solid #000', padding: '10px', marginBottom: '15px', pageBreakInside: 'avoid' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '5%', padding: '10px' }}>1.-</td><td style={{ width: '45%' }}><input type="text" className="confi-input-border" name="personal_1" value={formData.personal_1} onChange={handleChange} disabled={readOnly} /></td>
                                <td style={{ width: '5%', padding: '10px' }}>4.-</td><td style={{ width: '45%' }}><input type="text" className="confi-input-border" name="personal_4" value={formData.personal_4} onChange={handleChange} disabled={readOnly} /></td>
                            </tr>
                            <tr>
                                <td style={{ padding: '10px' }}>2.-</td><td><input type="text" className="confi-input-border" name="personal_2" value={formData.personal_2} onChange={handleChange} disabled={readOnly} /></td>
                                <td style={{ padding: '10px' }}>5.-</td><td><input type="text" className="confi-input-border" name="personal_5" value={formData.personal_5} onChange={handleChange} disabled={readOnly} /></td>
                            </tr>
                            <tr>
                                <td style={{ padding: '10px' }}>3.-</td><td><input type="text" className="confi-input-border" name="personal_3" value={formData.personal_3} onChange={handleChange} disabled={readOnly} /></td>
                                <td style={{ padding: '10px' }}>6.-</td><td><input type="text" className="confi-input-border" name="personal_6" value={formData.personal_6} onChange={handleChange} disabled={readOnly} /></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="confi-alert-red">RECUERDA QUE EN CASO DE EMERGENCIA, SI EXISTE UNA ATMOSFERA PELIGROSA, LA PERSONA QUE ESTA FUERA NUNCA DEBERA ACCEDER AL ESPACIO CONFINADO, SINO AVISAR INMEDIATAMENTE A LOS EQUIPOS DE EMERGENCIA.</div>

                    {/* FIRMAS */}
                    <div className="confi-signatures">
                        {[
                            { key: 'firma_jefe_equipo', label: 'Jefe de equipo' },
                            { key: 'firma_encargado', label: 'Encargado' },
                            { key: 'firma_jefe_obra', label: 'Jefe de Obra' }
                        ].map(f => (
                            <div key={f.key} className="confi-sign-box">
                                <div className="confi-sign-title">{f.label}</div>
                                {formData[f.key] ? (
                                    <div className="firma-display">
                                        <img src={formData[f.key].base64} alt={`Firma ${f.label}`} />
                                        <span className="firma-meta">{formData[f.key].nombre}<br/>{formData[f.key].fechaHora}</span>
                                        {!readOnly && <button type="button" onClick={() => clearSignature(f.key)} className="btn-clear-sign">Borrar Firma</button>}
                                    </div>
                                ) : (
                                    !readOnly && <button type="button" onClick={() => { setCurrentSignField(f.key); setShowSignaturePad(true); }} className="btn-sign-action">Firmar</button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* CONTROLES */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', marginTop: '30px', borderTop: '1px solid #ccc', paddingTop: '20px' }}>
                    {!readOnly && (
                        <button type="button" onClick={() => isStandalone ? handleGuardarDirecto() : onSave(formData)} className="btn-save" style={{ backgroundColor: '#1a237e' }}>
                            💾 Guardar Espacios Confinados
                        </button>
                        
                    )}
                    <button type="button" className="btn-print" onClick={handleDescargarPDF} style={{ backgroundColor: '#0288d1', color: '#fff', padding: '6px 15px', fontWeight: 'bold' }}>
                        🖨️ Imprimir Hoja
                    </button>
                    <button type="button" className="btn-close" onClick={() => isStandalone ? navigate('/dashboard') : onCancel()}>
                        {readOnly ? '❌ Cerrar' : '❌ Cancelar'}
                    </button>
                    
                </div>
            </div>

            {showSignaturePad && <SignaturePad onSave={handleSign} onCancel={() => setShowSignaturePad(false)} />}
        </div>
    );

    if (isPdfMode) return contenidoFormulario;

    return (
        <div className={isStandalone ? "container" : "excel-overlay"}>
            {contenidoFormulario}
            {showSignaturePad && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 100000 }}>
                    <SignaturePad onSave={handleSign} onCancel={() => setShowSignaturePad(false)} />
                </div>
            )}
        </div>
    );
};

export default PermisoEspaciosConfinados;